import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import userScoreSlice, { IUserScoreState } from './slices/score'
import userSlice, { IUserState } from './slices/user'
import responsePlanSlice, { IResponsePlanState } from './slices/responsePlan'
import scanSlice, { IScanState } from './slices/scan'
import findingsSlice, { IFindingsState } from './slices/findings'
import sidebarSlice, { ISidebarState } from './slices/sidebar'

export type TGlobalStore = IUserState &
  IUserScoreState &
  IResponsePlanState &
  IScanState &
  IFindingsState &
  ISidebarState & {
    resetStore: () => void
  }

const globalStore = create<TGlobalStore>()(
  devtools((set, get) => {
    const initialState = {
      ...userSlice(set, get),
      ...userScoreSlice(set, get),
      ...responsePlanSlice(set),
      ...scanSlice(set),
      ...findingsSlice(set),
      ...sidebarSlice(set),
    }
    return {
      ...initialState,
      resetStore: () => set(initialState as TGlobalStore, true),
    }
  }),
)

export default globalStore
